import React, {  useEffect, useState } from "react";
import ProfileHeader from "../../profile/components/ProfileHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { errorUI } from "../../../styled/Swal";
import { ClientGetAPI } from "../api/PortfolioAPI";
import { Eye } from "lucide-react";

function PortfolioList() {
  const { openSidebar } = useOutletContext();
  const [client,setClient] = useState([]);
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  useEffect(() => {
  const fetchLeads = async () => {
      setLoading(true);
      try {
        const res = await ClientGetAPI();
        if(res?.success){
          setClient(res?.res?.data?.data || [])
        }
      } catch (error) {
        errorUI(error?.message || "Failed to fetch leads");
      } finally {
      setLoading(false);
      }
  };
    fetchLeads();
  }, []);

  const handleNavigate = (data) => {
      navigate('/portfolio-data',{state:{clientData:data}})
  }

  return (
    <div className="rp-leads-page">
      <ProfileHeader onMenuClick={openSidebar} val="Client List" />
      {/* 
      <div className="rp-leads-filter-card">
        <h4 className="rp-leads-filter-title"><Filter size={18}/> Filter Leads : </h4>

        <div className="rp-leads-filters">
          <div className="rp-filter-group">
            <label>Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="All">All</option>
              <option value="New">New</option>
              <option value="In Progress">In Progress</option>
              <option value="Converted">Converted</option>
            </select>
          </div>

          <div className="rp-filter-group">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="rp-filter-group">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>
      </div> */}

    <div className="rp-leads-table">
      <div className="rp-leads-header">
        <div>Full Name</div>
        <div>Email</div>
        <div>Monthly Income</div>
        <div>Action</div>
      </div>

      {loading ? (
        <div className="rp-leads-loading">Loading Client...</div>
      ) : client.length > 0 ? (
        client.map((lead) => (
          <div className="rp-leads-row" key={lead._id}>
            <div>{lead.client_name || 'NA'}</div>
            <div>{lead.email || 'NA'}</div>
            <div>{lead.monthlyIncome || 'NA'}</div>
            <div onClick={()=>handleNavigate(lead)}><Eye size={18}/></div>
          </div>
        ))
      ) : (
        <div className="rp-leads-empty">No Client found</div>
      )}
    </div>
    </div>
  );
}

export default PortfolioList;
